import React from 'react';
import { AiFillDelete } from 'react-icons/ai';
import {
  Table,
  TableHead,
  Row,
  NormalTableHeader,
  SmallTableHeader,
  TableBody,
  NormalTableCell,
  SmallTableCell,
  RemoveIcon,
} from './tableElements';
import useAxiosPrivate from '../../../Hooks/useAxiosPrivate';

const MemberTable = ({ data, setData }) => {
  const axiosPrivate = useAxiosPrivate();

  const removeMember = (email) => {
    const confirmed = window.confirm(`Are you sure to remove ${email}`);
    if (!confirmed) return;

    axiosPrivate.post(
      '/changeMemberRole',
      JSON.stringify({
        memberEmail: email,
        memberRole: 2001,
      }),
      {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
      },
    ).then((res) => {
      if (res.data.status !== 'success') return console.log('Error updating role');
      const newData = data.filter((item) => item.Email !== email);
      return setData(newData);
    });
  };

  return (
    <Table>
      <TableHead>
        <Row>
          <NormalTableHeader>Email</NormalTableHeader>
          <NormalTableHeader>Full name</NormalTableHeader>
          <SmallTableHeader>Action</SmallTableHeader>
        </Row>
      </TableHead>
      <TableBody>
        {data.map((item, index) => (
          <Row dark={index % 2 === 1} key={item.Email}>
            <NormalTableCell data-label="Email">{item.Email}</NormalTableCell>
            <NormalTableCell data-label="Fullname">{`${item.First_Name} ${item.Last_Name}`}</NormalTableCell>
            <SmallTableCell>
              <RemoveIcon
                id={item.Email}
                onClick={() => removeMember(item.Email)}
              >
                <AiFillDelete />
              </RemoveIcon>
            </SmallTableCell>
          </Row>
        ))}
      </TableBody>
    </Table>
  );
};

export default MemberTable;
